import { Center, VStack, Box, Icon, Heading } from '@chakra-ui/react'
import type { ReactElement } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { RiFolderFill } from 'react-icons/ri'

const NoFilesOrFoldersView = (): ReactElement => {
  const { t } = useTranslation()

  return (
    <Center height="100%" width="100%">
      <VStack spacing={8}>
        <Box background="appPaleGreyThree" padding={5} borderRadius="full">
          <Icon as={RiFolderFill} boxSize={20} color="appClearBlue" />
        </Box>
        <VStack spacing={2} width="100%">
          <Trans t={t} i18nKey="drop_files_or_new">
            <Heading as="h4" fontSize="md" color="appBattleshipGrey">
              Drop Files here
            </Heading>
            <Heading
              as="h6"
              fontSize="sm"
              fontWeight="medium"
              color="appBattleshipGrey"
            >
              or use "New" button
            </Heading>
          </Trans>
        </VStack>
      </VStack>
    </Center>
  )
}

export default NoFilesOrFoldersView
